// Orb (NOW) screen help (the "?" beside the Focus / Rows switch under the orb). Plain words;
// keep it in step with the screen (apps/mobile/src/v10/NowView.tsx and v10/orb/).
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export function orbHelp(colors: { complete: string; partial: string; incomplete: string; reschedule: string }): ScreenHelpContent {
  return {
    title: 'The orb (NOW)',
    intro:
      "The orb is the moment you are in. It asks five short questions, one after the other, about the thing you picked on the compass. Answer them and you know where you are going, what you need, what to do, how to do it, and how it went.",
    sections: [
      {
        heading: 'Which orb you see',
        body: [
          'The orb follows what you last picked on the compass or the mountain: the area, and the ring (Step, Today, Aim, Goal or Endeavour). Pick a different dot there, tap Explore, and the orb changes to match.',
          'Step is one task. Today is the day. Aim is the week. Goal and Endeavour use the same layout as Aim. No area picked yet? Go up to the compass and pick one.',
        ],
      },
      {
        heading: 'The five letters',
        body: ['O R D E R down the left edge are the five questions. Tap a letter to open it. The bright one is the one you are on. It starts on the letter that fits the time of day.'],
        items: [
          { term: 'O  Orient', text: 'two boxes: "Where am I trying to go, and why?" and "What needs to be done to know I\'ve arrived?" They are filled in from ATLAS when it has something, and you can type your own.' },
          { term: 'R  Regulate', text: '"What resources do I need?" and "Do I have everything I need?" POROS writes a first answer. Type over it to use your own. It needs an objective set in ATLAS first.' },
          { term: 'D  Direct', text: '"What should I do?" and "In what order?" Filled in from your KYRS list. Type over it to use your own.' },
          { term: 'E  Execute', text: '"What am I doing right now?" and "How do I carry it out?" On a Step it shows the time left and your routine or sub-steps. Higher up it shows how much of the list is done.' },
          { term: 'R  Revise', text: 'how it went. Four round buttons and a note box. Tap a button again to take it back.' },
        ],
      },
      {
        heading: 'The Revise buttons',
        items: [
          { term: 'Check', text: 'Complete.', color: colors.complete },
          { term: 'Half moon', text: 'Partially complete.', color: colors.partial },
          { term: 'Cross', text: 'Incomplete.', color: colors.incomplete },
          { term: 'Clock', text: 'Reschedule.', color: colors.reschedule },
        ],
        body: ['On a Step, Complete also ticks the task off, and taking it back un-ticks it. The note box asks "What happened, and what needs to change?" The arrow beside it opens CLIO.'],
      },
      {
        heading: 'Writing and saving',
        body: [
          'Everything you type saves by itself when you tap out of the box. There is no Save button.',
          'Your answers are kept per area and per time period, so each orb and each day has its own.',
        ],
      },
      {
        heading: 'Focus and Rows',
        body: [
          'The two buttons under the orb switch the view. ◐ Focus fills the orb with one letter at a time. ☰ Rows shows all five as thin lines. Tap a line to open it. Your choice is remembered.',
          'In Rows, the white dot on top of the rim shows every answer at once, in five equal bands. Tap it again to go back to one open row.',
        ],
      },
      {
        heading: 'Moving around',
        items: [
          { term: '▲', text: 'up to the compass.' },
          { term: '▶', text: "opens the tool behind the letter you are on: ATLAS for Orient, POROS for Regulate, KYRS for Direct, CLIO for Revise. Execute opens METIS, your routine, or the next smaller orb, depending on which orb you are on. Swiping right across the orb does the same." },
        ],
      },
    ],
  };
}
